import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { UtilityService } from '../../services/utility/utility.service';

import { IEvent } from '../../services/announcement/models/event.interface';
import moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'upsc-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
})
export class EventListComponent implements OnInit, OnChanges {
  @Input() items: IEvent[];

  public displayedItems: IEvent[];

  private selectedDateValue: string;

  constructor(private utilityService: UtilityService) {
  }

  public ngOnInit() {
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.onItemsChanged(changes['items']);
  }

  private onItemsChanged(change: SimpleChange) {
    if (!change || !change.currentValue) {
      return;
    }

    this.displayedItems = change.currentValue.map(
      (item) => {
        item.TitleTooltip = this.utilityService.stripTags(item.Title);

        return item;
      },
    );

    this.filterEvents(this.selectedDateValue);
  }

  public onMonthSelected(dateItem: string) {
    this.selectedDateValue = dateItem;
    this.filterEvents(dateItem);
  }

  private filterEvents(dateItem: string) {
    if (!this.items) {
      return;
    }

    if (dateItem === 'all') {
      this.displayedItems = _.cloneDeep(this.items.filter(item => !!item.EventStartDate));
      return;
    }

    this.displayedItems = _.cloneDeep(this.items.filter(
      (item) => {
        const selectedDate = moment(dateItem, 'YYYY-MM-DD');
        const startOfMonth = selectedDate.startOf('month');
        const endOfMonth = selectedDate.endOf('month');

        return !!item.EventStartDate && moment(item.EventStartDate).isBetween(startOfMonth, endOfMonth, 'month', '[]');
      },
    ));
  }
}
